// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./Components/Header/Header";
import Home from "./Pages/Home";
import Login from "./Components/Login/Login";
import Signup from "./Components/Signup/Signup";
import Posts from "./Components/Posts/Posts";

import Create from "./Components/Create/Create";
import View from "./Components/View/View";
import AllPosts from "./Components/ViewMoreAllPosts/AllPosts";
import EditMachine from "./Components/Edit/Edit"; // adjust path if different
import ViewMore from "./Pages/ViewMore";

// Single-profile page (one place for profile UI)
import ProfilePage from "./Pages/ProfilePage"; // keep as-is

// Public Plans page (not admin)
import PlansPage from "./Pages/PlansPage";

// Admin pages
import Dashboard from "./Pages/Admin/Dashboard";
import UsersPage from "./Components/admin/UsersPage";
import ListingsPage from "./Pages/Admin/ListingsPage";
// New admin plans pages (make sure these files exist)
import PlansMainPage from "./Pages/Admin/PlansMainPage";
import SellerPlansPage from "./Pages/Admin/SellerPlansPage";
import BuyerPlansPage from "./Pages/Admin/BuyerPlansPage";

import AdminLogin from "./Pages/Admin/Login";
import RequireAdmin from "./Components/admin/RequireAdmin";

function AppContent() {
  const location = useLocation();
  const pathname = location?.pathname || "";

  // treat anything under /admin as admin panel (including /api/admin/login)
  const isAdminRoute = pathname.startsWith("/admin");

  return (
    <>
      {/* Only render Header when NOT on admin routes */}
      {!isAdminRoute && <Header />}

      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/create" element={<Create />} />
        <Route path="/view" element={<View />} />
        <Route path="/machines/:id" element={<View />} />
        <Route path="/viewmore" element={<AllPosts />} />
        <Route path="/category/:slug" element={<ViewMore />} />
        <Route path="/allposts" element={<AllPosts />} />

        

        {/* Profile: single page */}
        <Route path="/profile" element={<ProfilePage />} />

        {/* Public Plans (non-admin) */}
        <Route path="/plans" element={<PlansPage />} />

        <Route path="/edit/:id" element={<EditMachine />} />
        <Route path="/edit-listing/:id" element={<EditMachine />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <Dashboard />
            </RequireAdmin>
          }
        />

        <Route
          path="/admin/users"
          element={
            <RequireAdmin>
              <UsersPage />
            </RequireAdmin>
          }
        />

        <Route
          path="/admin/listings"
          element={
            <RequireAdmin>
              <ListingsPage />
            </RequireAdmin>
          }
        />

        {/* Admin Plans */}
        <Route
          path="/admin/plans"
          element={
            <RequireAdmin>
              <PlansMainPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/plans/seller"
          element={
            <RequireAdmin>
              <SellerPlansPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/plans/buyer"
          element={
            <RequireAdmin>
              <BuyerPlansPage />
            </RequireAdmin>
          }
        />

        {/* fallback */}
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
